import CartproductTile from './partials/cart-tile.hbs';
const initializeCart = () => {
    $('.cart-btn').on('click', function (e) {
        console.log('I am clicked');
    });
    const $CartTiles = $('.cart-tiles');
    Array.from({ length: 1 }, () => {
        $CartTiles.append(CartproductTile);
    });
};
function showMoreLess() {
    let $this = $(this);
    $this
        .parents('.cart-tile__content__meta--pack')
        .find('li:nth-child(n+1)')
        .toggle();
    $this.toggleClass('flip');
    console.log('clicked', $this.parents('.cart-tile__content__meta--pack'));
    $this.children('.show-text--more, .show-text--less').toggleClass('d-none');
}

$(() => {
    initializeCart();
    $(document).on('click', '.cart-tile__show-more', showMoreLess);
});
